// extracted by mini-css-extract-plugin
export default {"brandPromo":"gG-z","carousel":"hG-z"};